/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfNameValueDto } from "../models/AjaxResponseOfListOfNameValueDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class MobiautoAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getColors(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-colors",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getFuelTypes(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-fuel-types",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getMakes(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-makes",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getModels({
    makeId,
  }: {
    makeId?: number;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-models",
      query: {
        makeId: makeId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getOptionals(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-optionals",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getTransmissions(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-transmissions",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getVersions({
    modelId,
    modelYear,
  }: {
    modelId?: number;
    modelYear?: number;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-versions",
      query: {
        modelId: modelId,
        modelYear: modelYear,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getVersionsMotorcycle({
    modelId,
    modelYear,
  }: {
    modelId?: number;
    modelYear?: number;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/mobiauto/get-versions-motorcycle",
      query: {
        modelId: modelId,
        modelYear: modelYear,
      },
    });
  }
}
